import { SOFTLINE_API_WEBDOC_DELETE_FILE } from '../bauprofi.api';
import { ApiDataAccess, ApiResourceLocation, ResourceService } from '@softline/core';
import { firstValueFrom } from 'rxjs';
import { WebDocumentFile } from '../types/web-document';

export async function deleteFile(service: ApiDataAccess, file: WebDocumentFile) {
  const location = {
    path: SOFTLINE_API_WEBDOC_DELETE_FILE,
  } as ApiResourceLocation;

  return await service.create<object, WebDocumentFile>(location, {
    path: file.path,
    url: file.url,
  });
}
